export interface ISubscription {
  id: string;
  name: string;
  durationType: SubscriptionDurationTypesEnum;
  duration: number;
  isVisible: boolean;
  isTrial: boolean;
  credits: number;
  price: number;
  description: string;
}

export interface IUserSubscription {
  id: string;
  userId: string;
  subscriptionId: string;
  credits: number;
  usageCredits: number;
  status: UserSubscriptionStatusEnum;
  isDeleted: boolean;
  nextPaymentDate: string;
  cancelAt: string | null;
  stripeId: string;
  subscription: ISubscription;
}

export enum UserSubscriptionStatusEnum {
  incomplete = "incomplete",
  incomplete_expired = "incomplete_expired",
  trialing = "trialing",
  active = "active",
  past_due = "past_due",
  canceled = "canceled",
  unpaid = "unpaid",
  paused = "paused",
}

export enum SubscriptionDurationTypesEnum {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}
